module.exports = __webpack_public_path__ + "static/img/day2.daca275.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cultours/tour4/day2.jpg
// module id = Oc2U
// module chunks = 0